import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { addNewItem as onAddNewItem } from "store/products/actions"
import { getAllSuppliers as onGetAllSuppliers } from "store/products/actions"

import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { showSuccessToast, validateEmail } from "helpers/function_helper"

const AddNewSupplier = props => {
  const dispatch = useDispatch()

  const [validation, setValidation] = useState({
    supplierName: null,
    supplierEmail: null
  })
  const [showLoading, setShowLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [supplierName, setSupplierName] = useState('')
  const [supplierAddress, setSupplierAddress] = useState('')
  const [supplierMobile, setSupplierMobile] = useState('')
  const [supplierPhone, setSupplierPhone] = useState('')
  const [supplierFax, setSupplierFax] = useState('')
  const [supplierEmail, setSupplierEmail] = useState('')
  const [supplierGSTIN, setSupplierGSTIN] = useState('')
  const [supplierOpeningBalance, setSupplierOpeningBalance] = useState('0')

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('inp-supp-name').focus();
      document.getElementById('inp-supp-name').select();
    }, 250);
    
    if(props.enteredText != ''){
      setSupplierName(props.enteredText)
    }
  }, [props.enteredText])

  useEffect(() => {
    if(props.isEdit){
      setSupplierName(props.detailsForEdit.name)
      setSupplierAddress(props.detailsForEdit.address)
      setSupplierMobile(props.detailsForEdit.mobile)
      setSupplierPhone(props.detailsForEdit.phone)
      setSupplierFax(props.detailsForEdit.fax)
      setSupplierEmail(props.detailsForEdit.email)
      setSupplierGSTIN(props.detailsForEdit.gstin)
      setSupplierOpeningBalance(props.detailsForEdit.openingBalance)
    }
  }, [props.detailsForEdit])

  const onChangeValidation = (fieldName, value) => {
    const modifiedV = { ...validation }
    if (value !== "") {
      modifiedV[fieldName] = true
    } else {
      modifiedV[fieldName] = false
    }
    setValidation(modifiedV)
  }

  function validateForm() {
    const modifiedV = { ...validation }
    let formValid = true;
    if(supplierName && supplierName != ""){
      modifiedV["supplierName"] = true
    }
    else{
      modifiedV["supplierName"] = false
      formValid = false
    }

    if(supplierEmail && supplierEmail!=""){
      if(validateEmail(supplierEmail)){
        modifiedV["supplierEmail"] = true
      }
      else{
        modifiedV["supplierEmail"] = false
        formValid = false
      }
    }
    setValidation(modifiedV)
    return formValid
  }

  async function addItem() {
    const formValid = validateForm()
    if(formValid){
      setShowLoading(true)
      const response = await onAddItemDirect({
        'name': supplierName,
        'address' : supplierAddress,
        'mobile' : supplierMobile,
        'phone' : supplierPhone,
        'fax' : supplierFax,
        'email' : supplierEmail,
        'gstin' : supplierGSTIN,
        'openingBalance' : supplierOpeningBalance
      }, 'Supplier')

      setShowLoading(false)
      if(response.status == 'success'){
        dispatch(onGetAllSuppliers(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Added Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  async function editItem() {
    const formValid = validateForm();
    if(formValid){
      setShowLoading(true)
      const response = await onEditItemDirect({
          'value': props.detailsForEdit.value,
          'name': supplierName,
          'address' : supplierAddress,
          'mobile' : supplierMobile,
          'phone' : supplierPhone,
          'fax' : supplierFax,
          'email' : supplierEmail,
          'gstin' : supplierGSTIN,
          'openingBalance' : supplierOpeningBalance
        }, 'Supplier')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetAllSuppliers(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Edited Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  return (
    <React.Fragment>
      <div className="">
        <Container fluid={true} className="min-height-700">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <Form>
                      {errorMessage !== '' ? <Alert color="danger">{errorMessage}</Alert> : null}
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inp-supp-name">
                              Name
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inp-supp-name"
                              maxLength="150"
                              value={supplierName}
                              onChange={event => {
                                onChangeValidation("supplierName", event.target.value.trim())
                                setSupplierName(event.target.value)
                              }}
                              invalid={
                                validation["supplierName"] !== true &&
                                validation["supplierName"] !== null
                              }
                            />
                            {(validation["supplierName"] === false) &&
                              <div className="custom-error">
                                Please enter the Supplier Name
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpname">
                              Address
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpname"
                              maxLength="200"
                              value={supplierAddress}
                              onChange={event => {
                                onChangeValidation("supplierAddress", event.target.value.trim())
                                setSupplierAddress(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpmobile">
                              Mobile
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpmobile"
                              maxLength="15"
                              value={supplierMobile}
                              onChange={event => {
                                onChangeValidation("supplierMobile", event.target.value.trim())
                                setSupplierMobile(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpphone">
                              Phone
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpphone"
                              maxLength="20"
                              value={supplierPhone}
                              onChange={event => {
                                onChangeValidation("supplierPhone", event.target.value.trim())
                                setSupplierPhone(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpemail">
                              Email
                            </Label>
                            <Input
                              type="email"
                              className="form-control"
                              id="inpemail"
                              maxLength="150"
                              value={supplierEmail}
                              onChange={event => {
                                onChangeValidation("supplierEmail", event.target.value.trim())
                                setSupplierEmail(event.target.value)
                              }}
                              invalid={
                                validation["supplierEmail"] !== null && validation["supplierEmail"] !== true
                              }
                            />
                            {(validation["supplierEmail"] === false) &&
                              <div className="custom-error">
                                Please enter a valid Email
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpsgstin">
                              GSTIN
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpsgstin"
                              maxLength="50"
                              value={supplierGSTIN}
                              onChange={event => {
                                onChangeValidation("supplierGSTIN", event.target.value.trim())
                                setSupplierGSTIN(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="openingBalance">
                              Opening Balance
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="openingBalance"
                              maxLength="12"
                              value={supplierOpeningBalance}
                              onChange={event => {
                                onChangeValidation("supplierOpeningBalance", event.target.value.trim())
                                setSupplierOpeningBalance(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-5">
                        <Col lg="12">
                          <div className="d-inline-block float-end">
                            {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="me-3 mt-3" color="primary" />}
                            {props.isEdit === true ? 
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                editItem()
                              }}
                              disabled={showLoading}
                              >
                                SAVE
                            </Button>
                            :
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                addItem()
                              }}
                              disabled={showLoading}
                              >
                                ADD
                            </Button>
                            }
                            </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewSupplier.propTypes = {
  newlyAddedValue: PropTypes.func,
  detailsForEdit: PropTypes.any,
  isEdit:PropTypes.bool,
  enteredText:PropTypes.any,
}

export default AddNewSupplier
